import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import Utils from "../../../../utils/Utils";
import {api} from "../../../../services/Api/api";
import {ReactComponent as GiftIco} from "../../../../../images/icons/gift.svg";
import PopupModal from "../../../Modal/PopupModal";
import {PromotionApi} from "../../../../services/Api/types";
import PromotionInfoForOldVersion from "./PromotionInfoForOldVersion";
import PromotionInfoForNewVersion from "./PromotionInfoForNewVersion";

interface Props {
    name: any,
    promotionId: any,
    onHide: () => void,
    onShow?: () => void
}

function PromotionInfoModalComponent(props: Props) {
    const [promotion, setPromotion] = useState<PromotionApi | undefined>(undefined);
    const [error, setError] = useState<string | undefined>(undefined);
    const {t} = useTranslation();

    useEffect(() => {
        showPromotionInfo(props.promotionId)
    }, [])

    const fetchPromotion = async (promotionId: any) => {
        return api.getPromotion(promotionId);
    }

    const showPromotionInfo = async (promotionId: any) => {
        try {
            const promotionConfig = await fetchPromotion(promotionId)
            setPromotion(promotionConfig);
        } catch (err) {
            setError(t('modules.promotion.field.problem_with_promotion_fetching.title'));
        }
    }

    return <PopupModal
        title={props.name}
        description={promotion?.description ? Utils.nl2brString(promotion.description) : undefined}
        show
        onHide={props.onHide}
        onShow={props.onShow}
        loading={!promotion}
        headerIcon={<GiftIco/>}
        bodyContent={
            <>
                {
                    !promotion ? <></> : (
                        error ? <div className={"alert alert-danger"}>{error}</div> : (
                            <div className="promotion-info-modal-content">
                                <ul className="list-unstyled">
                                    {promotion.new_version ? <PromotionInfoForNewVersion promotion={promotion}/> :
                                        <PromotionInfoForOldVersion promotion={promotion}/>}
                                </ul>
                            </div>
                        )
                    )
                }
            </>
        }
    />
}

export default PromotionInfoModalComponent;